export const formatWeight = (value) => value != null ? `${parseFloat(Number(value).toFixed(3))} lbs.` : '';
export const formatPercent = (decimals) => (value) => value != null ? (value * 100).toFixed(decimals) + '%' : '\u2014';
export const formatDecimal = (decimals) => (value) => value != null ? value.toFixed(decimals) : '';

export const formatDate = (value) => {
    if (!value) return '';
    return new Date(value).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
};
